var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._b(
      {
        ref: "select",
        on: { change: _vm.changeValue, "visible-change": _vm.onVisibleChange },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      },
      "el-select",
      _vm.params.selectProps,
      false
    ),
    [
      _vm.params.isGroup
        ? _vm._l(_vm.params.options, function(group) {
            return _c(
              "el-option-group",
              { key: group.label, attrs: { label: group.label } },
              _vm._l(group.options, function(item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: {
                    label: item[_vm.params.tagName],
                    value: item[_vm.params.tagValue]
                  }
                })
              }),
              1
            )
          })
        : _vm._l(_vm.params.options, function(item, index) {
            return _c("el-option", {
              key: index,
              attrs: {
                label: item[_vm.params.tagName],
                value: item[_vm.params.tagValue]
              }
            })
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }